import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Eye, CalendarCheck, Bell } from 'lucide-react';
import { buildLoginUrl, buildSignupUrl } from '@/lib/redirect';

interface AuthGateCardProps {
  returnTo: string;
  className?: string;
  'data-testid'?: string;
}

const benefits = [
  { icon: Eye, text: 'Se hela beskrivningen' },
  { icon: CalendarCheck, text: 'Boka plats' },
  { icon: Bell, text: 'Få uppdateringar om ändringar' },
] as const;

export function AuthGateCard({ returnTo, className, ...props }: AuthGateCardProps) {
  return (
    <Card className={`border-border/60 bg-muted/20 ${className ?? ''}`} {...props}>
      <CardContent className="p-6 space-y-5">
        <div className="space-y-2">
          <h2 className="text-lg font-semibold text-foreground leading-snug">
            Den här kvällen är för Farmly-medlemmar
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Skapa konto gratis för att se detaljer, boka plats och få uppdateringar.
          </p>
        </div>

        <ul className="space-y-2.5">
          {benefits.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-2.5 text-sm text-foreground/80">
              <Icon className="h-4 w-4 shrink-0 text-primary/70" aria-hidden />
              <span>{text}</span>
            </li>
          ))}
        </ul>

        <div className="space-y-2.5 pt-1">
          <Button asChild size="lg" className="w-full">
            <Link to={buildSignupUrl(returnTo)}>
              Skapa konto gratis
            </Link>
          </Button>
          <Button asChild variant="ghost" size="sm" className="w-full text-muted-foreground hover:text-foreground">
            <Link to={buildLoginUrl(returnTo)}>
              Logga in
            </Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
